import { Component, Injector, OnInit } from '@angular/core';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { isNullOrEmpty, readBlobAsJson } from 'src/app/core/utils/common-functions';
import { DeliveryOrderService } from 'src/app/features/transport-operation/services/delivery-order.service';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { BillService } from '../../../service/bill.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'laas-bill-import',
  templateUrl: './bill-import.component.html',
  styleUrls: ['./bill-import.component.scss']
})
export class BillImportComponent extends SessionBaseComponent implements OnInit {

  // readonly permissionCode : PermissionConstants = PermissionConstants.ViewRFQSetting;
  documentOptions: any[];
  selectedDocument: string;
  docs: any[];
  isLoading: boolean;
  selectedDoc: any;

  previewData: any[] = [];
  columns: any[] = [];

  uploadBtn: boolean = true;

  billCodeKeyOptions: any[] = [];
  billCodeKey: string = "";
  billFile: any;

  billSample: any[] = [];

  constructor(
    injector: Injector,
    private commonDataService: CommonDataService,
    private dropdownOptionsService: DropdownOptionsService,
    private dOService: DeliveryOrderService,
    private facilityService: FacilityService,
    private billService: BillService,
    private datePipe: DatePipe,
  ) {
    super(injector);

    this.documentOptions = [];
    this.selectedDocument = "";
    this.docs = [];
    this.isLoading = false;

  }


  async ngOnInit(): Promise<void> {

    await super.ngOnInit();

    let facility = this.laasSetting.facility;

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'BillingExcelType').subscribe({
      next: result => {
        this.billCodeKeyOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey}-${x.codeDesc}`,
            value: x.codeKey,
          };
        });
        this.billCodeKey = this.billCodeKeyOptions[0].value;
      }
    });

  }


  preview(event: any): void {

    this.isLoading = true;
    this.uploadBtn = true;

    this.billService.previewExcel(event.files[0]).subscribe({
      next: rsp => {
        this.billFile = event.files[0];
        this.billSample = rsp.billSample;
        this.uploadBtn = false;
        this.isLoading = false;
        this.translateService.get('BillSearch.Success.PreviewSuccess')
          .subscribe({
            next: msg => {
              this.toastService.success(msg, false);
            }
          });
      },
      error: rsp => {
        this.isLoading = false;
        this.translateService.get('BillSearch.Alert.PreviewFail')
          .subscribe({
            next: msg => {
              this.toastService.warn(msg, false);
            }
          });
      },
      complete: () => {

      }
    });

  }


  upload(): void {
    this.loader.show();
    this.isLoading = true;
    let codeKey = this.billCodeKey;

    this.billService.importBillExcel(this.billFile, codeKey, this.userProfile.userName, this.userProfile.userType, this.laasSetting.facility).subscribe({
      next: async (rsp) => {
        this.billFile = null;
        this.uploadBtn = true;
        this.isLoading = false;
        this.loader.hide();
        const contentType = rsp.headers.get('Content-Type');
        if(contentType?.includes('application/octet-stream')) {
          let fileDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
          const file = rsp.body;
          file.name = fileDate + "_Bill_Check.xlsx";
          const url = URL.createObjectURL(file);
          let a: any = document.createElement('a');
          a.href = url
          a.download = file.name;
          a.click();
          URL.revokeObjectURL(url);
        } else {
          const result = await readBlobAsJson(rsp.body);
          this.translateService.get('BillSearch.Success.UploadSuccess').subscribe({
              next: msg => {
                this.toastService.success(msg +" batchNo:" + result , true);
              }
            });
          let uploadBatchNo = result;
          this.routeStateService.navigateTo('/BillConfig/Bill', { uploadBatchNo: uploadBatchNo , errMsgs: [] });
        }

      },
      error: async (rsp) => {
        console.log("rsp", rsp);
        const result: any = await readBlobAsJson(rsp.error);
        console.log("result", result);
        this.uploadBtn = true;
        const msg = result.errorMsg ? result.errorMsg : result;
        this.toastErrorMessage(msg);
        this.loader.hide();
        this.isLoading = false;
      },
      complete: () => {
        this.loader.hide();

      }
    });


  }

  onClear() {
    this.uploadBtn = true;
  }

  showUploadBtn() {
    if (this.uploadBtn) {
      return true;
    } else {
      return false;
    }
  }


}
